export default {"src":"/_next/static/media/avatar_40.cbd2d0a8.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};